<template>
  <div class="container-fluid dark-green">
    <header class="row">
      <div class="col-12">
        <b-navbar toggleable="lg" type="dark" class="navbar-top">
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <div class="logo-principal">
            <a href="https://www.proetica.org.pe/" target="_blank"><img src="https://www.proetica.org.pe/wp-content/themes/gobambiental/images/logo-proetica-white.png" alt="logo"></a>
          </div>
          <div class="ml-3">
            <a href="#">
              <img src="@/assets/logo_madera.png" alt="logo">
            </a>
          </div>    
          
      
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto">
              <li class="nav-item">
                <router-link class="align-self-center" :to="{ name: 'list' }">
                  <font-awesome-icon icon="tree" />
                  <span>{{$t('inicio')}}</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="align-self-center" :to="{ name: 'Plataforma' }">
                  <font-awesome-icon icon="database" />
                  <span>{{$t('observatorio')}}</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{ name: 'Planes' }">
                  <font-awesome-icon icon="folder-open" />
                  <span>{{$t('explorar')}}</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{ name: 'Involucrados' }">
                  <font-awesome-icon icon="users" />
                  <span>{{$t('actores')}}</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{ name: 'MapaPage' }">
                  <font-awesome-icon icon="map-marked" />
                  <span>{{$t('mapa')}}</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{ name: 'Contacto' }">
                  <font-awesome-icon icon="address-book" />
                  <span>{{$t('contacto')}}</span>
                </router-link>
              </li>         
              <b-nav-item-dropdown class="p-0" right>
                <template #button-content>
                  <font-awesome-icon icon="globe"/> <span style="text-transform: uppercase;">{{ langSelected }}</span>
                </template>
                <b-dropdown-item @click="language('es')">ES</b-dropdown-item>
                <b-dropdown-item @click="language('en')">EN</b-dropdown-item>
              </b-nav-item-dropdown>
                
              
            </b-navbar-nav>
      
          </b-collapse>
        </b-navbar>
      </div>
    </header>
  </div>

</template>


<script>
  
  // import BuscadorMenu from '../components/BuscadorMenu.vue'
  
  export default {
    name: '',
    data() {
      return {
        langSelected: `es`
      }
    },
    mounted() {
      this.langSelected = this.$route.params.locale
    },
    methods:{
      language(locale) {
        this.langSelected = locale
        this.$router.push({ name: this.$route.name, params: { ...this.$route.params, locale }, query: this.$route.query })
      }
    }
  }
</script>